import { getVueTemplate } from "../../_imports/utils/utils.common";
import FormsBaseSelectField from "./_imports/forms-base-select-field.vue";
import FormsSelectField from "./forms-select-field.vue";

export default {
	name: 'forms-country-select-field',
	template: getVueTemplate('forms-country-select-field'),
	mixins: [
		FormsBaseSelectField
	],
	components: {
		FormsSelectField
	},
	computed: {
		formattedOptions() {
			return this.field.countries.map(country => ({
				text: country.name,
				value: country.englishName
			}));
		}
	}
};